import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Dev-only: expose engine + Golden Master harness on window for tests.
// NB: The runtime-error suppression for the two documented benign
// ResizeObserver browser advisories lives in `public/index.html` as an
// inline <head> script — it MUST run before the CRA overlay registers
// its capture-phase listener, which is not possible from this bundle.
if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line global-require
  require("@/devHooks");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
